// axios
import axios from 'axios'

const domain = ""
import themeConfig from '@/../themeConfig.js'

export default axios.create({
  baseURL: themeConfig.home(''),
  headers:{
    'Content-Type':'application/json',
    'Accept':'application/json',
    'Authorization' :'Bearer ' + localStorage.getItem("accessToken") || localStorage.accessToken
  },
  domain
})
